import { Box, Button, Dialog, IconButton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { PaymentPopUpCloseIcon } from "../../../assets/icons/MUI/PaymentIcons";
import EndPaymentAlert from "../../../assets/images/payments/end-payment-link.png";

import { EndPaymentLinkPopUpProps } from "../payment.types";

const EndPaymentLinkPopUp = ({ onClose, open, endPaymentLinkHandler }: EndPaymentLinkPopUpProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      onClose={onClose}
      open={open}
      sx={{
        "& .MuiDialog-paper": {
          width: "100%",
          maxWidth: "640px",
          borderRadius: "12px",
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
          padding: "24px 0",
          borderBottom: "1px solid #E4E7EC",
        }}
      >
        <Typography
          component="h3"
          sx={{
            color: "#101828",
            textAlign: "center",
            fontFamily: "Montserrat",
            fontSize: "18px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "28px",
            width: "100%",
          }}
        >
          {t("pages.payment.paymentLinks.endPaymentLink")}
        </Typography>
        <IconButton
          onClick={() => onClose()}
          sx={{
            position: "absolute",
            right: "16px",
            top: "50%",
            transform: "translateY(-50%)",
          }}
        >
          <PaymentPopUpCloseIcon />
        </IconButton>
      </Box>
      <Box
        sx={{
          display: "fleX",
          flexDirection: "column",
          alignItems: "center",
          rowGap: "24px",
        }}
      >
        <img src={EndPaymentAlert} width="96px" height="96px" />
        <Box
          sx={{
            display: "fleX",
            flexDirection: "column",
            rowGap: "16px",
            paddingBottom: "24px",
            marginBottom: "12px",
          }}
        >
          <Typography
            component="h2"
            sx={{
              color: "var(--Dark---1000, #111)",
              textAlign: "center",
              fontFamily: "Montserrat",
              fontSize: "24px",
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: "32px",
            }}
          >
            {t("pages.payment.paymentLinks.endPaymentLink")}
          </Typography>
          <Typography
            component="p"
            sx={{
              color: "var(--Gray-Gray-700, #5E6278)",
              textAlign: "center",
              fontFamily: "Montserrat",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "24px",
              maxWidth: "450px",
            }}
          >
            {t("pages.payment.paymentLinks.paymentLinkDescription")}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: "fleX",
          justifyContent: "flex-end",
          padding: "12px 24px",
          gap: "12px",
          borderTop: "1px solid #EAECF0",
        }}
      >
        <Button variant="outlined-md" onClick={onClose}>
          {t("pages.payment.paymentLinks.cancel")}
        </Button>
        <Button variant="primary-md" onClick={endPaymentLinkHandler}>
          {t("pages.payment.paymentLinks.end")}
        </Button>
      </Box>
    </Dialog>
  );
};

export default EndPaymentLinkPopUp;
